import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { ReactiveFormsModule } from '@angular/forms';

// Shared modules
import { UIModule } from '../ui.module';
import { SharedModule } from '../shared';
import { WorldMapRouting } from './world-map.routing';

// Module's pages components.
import { BaseComponent } from './base';
import { MapComponent } from './map.component';
import { TooltipComponent } from './tooltip.component';

import { WorldMapService } from './world-map.service';
import { ShowDlgWorldOopsService } from './show-dlg-world-oops.service';
import { ShowDlgWorldWelcomeService } from './show-dlg-world-welcome.service';
import { ShowDlgWorldTipsService } from './show-dlg-world-tips.service';
import { ShowDlgGCLIncreasedService } from './show-dlg-gcl-increased.service';

import { WorldPreferencesComponent } from './preferences.component';
import { DlgWorldPreferencesComponent } from './dlg-preferences';
import { ShowDlgWorldPreferencesService } from './show-dlg-preferences.service';

@NgModule({
    imports: [
        CommonModule,
        MatSliderModule,
        ReactiveFormsModule,
        // Shared modules
        UIModule,
        SharedModule,
        // Current module imports
        WorldMapRouting
    ],
    declarations: [
        // Section Components
        BaseComponent,
        MapComponent,
        TooltipComponent,

        WorldPreferencesComponent,
        DlgWorldPreferencesComponent
    ],
    exports: [
    ],
    providers: [
        WorldMapService,
        ShowDlgWorldOopsService,
        ShowDlgWorldWelcomeService,
        ShowDlgWorldTipsService,
        ShowDlgGCLIncreasedService,
        ShowDlgWorldPreferencesService
    ],
    entryComponents: [
        DlgWorldPreferencesComponent
    ]
})
export class WorldMapModule { }

// TODO: angularjs downgrade service
import { downgradeInjectable } from '@angular/upgrade/static';

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('ShowDlgWorldWelcomeService', downgradeInjectable(ShowDlgWorldWelcomeService) as any);

angular.module('app')
    .factory('ShowDlgWorldTipsService', downgradeInjectable(ShowDlgWorldTipsService) as any);

angular.module('app')
    .factory('ShowDlgGCLIncreasedService', downgradeInjectable(ShowDlgGCLIncreasedService) as any);
